// @ts-ignore types resolved at build-time from workspace
import { createTheme } from '@classify/react-core-components/styles';
// @ts-ignore types resolved at build-time from workspace
import { defaultTheme } from '@classify/react-core-components/Theme';

export default function getOcTheme() {
  return createTheme(defaultTheme as any);
}
